import { OrderTransactionSection } from "./sections/order-transaction.section";

export const OrderTransactionPage = () => <OrderTransactionSection />;
